import { type ILayout } from '@inpart-io/padme-iap';
import { type GetterTree } from 'vuex';

import { type ILayoutState } from './types';

export const GET_FROM_CLASS_NAME = 'getFromClassName';
export const GET_REFRESH_TIMESTAMP = 'getRefreshTimestamp';
export const GET_COMPLETE = 'getComplete';

export const getters: GetterTree<ILayoutState, unknown> = {
    [GET_FROM_CLASS_NAME]: (_state: ILayoutState) => {
        return (forClassName: string): ILayout | undefined => {
            const layoutId = _state.layoutByClassName.get(forClassName);
            return _state.dataObjectList.get(layoutId);
        };
    }
};
